var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkipNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#skip_next_svg__clip0_1442_3591)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6 18 8.5-6L6 6v12Zm2-8.14L11.03 12 8 14.14V9.86ZM16 6h2v12h-2V6Z"
}))));
export default SvgSkipNext;